import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { TextInputRootBase } from "./TextInputRootBase";
import {
    TextInputRootBoxProps,
    formInputTheme,
    getBackgroundColor,
    getBorderColor,
    getBorderWidth,
} from "./formInputTheme";

export const TextInputRootBox = withFocusToggleClassName(styled(TextInputRootBase)<TextInputRootBoxProps>`
    border-style: solid;
    border-width: ${getBorderWidth}px;
    border-color: ${getBorderColor};
    border-radius: ${({ themeMode }) => formInputTheme.borderRadius(themeMode)};
    background-color: ${getBackgroundColor};
    // This is necessary, and not baked into the StyledInput, to give DatePickerInput a way to override padding for the calendar icon button
    padding-right: ${({ hasContentAfter }) =>
        hasContentAfter ? "var(--sds--form--padding-x--has-icon, 4px)" : "var(--sds--form--padding-x--default, 0px)"};
    ${({ themeMode, validationState }) =>
        formInputTheme.focusRing.enabled(themeMode) &&
        createFocusRingStyles({
            gap: formInputTheme.focusRing.offset(themeMode),
            componentBorderWidth:
                validationState === "error"
                    ? formInputTheme.borderWidth.error(themeMode)
                    : formInputTheme.borderWidth.rest(themeMode),
            componentRadius: formInputTheme.borderRadius(themeMode),
            theme: themeMode,
            focusSelector: ":focus-within",
        })}

    & input {
        outline: none;
    }
`);
